import styled from 'styled-components'
import { BREAKPOINTS } from '../../constants/breakpoints'

export const UserInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
`

export const InfoContainer = styled.div`
  padding: 8px 20px;
  margin-bottom: 16px;
  background: white;
  width: 100%;

  @media ${BREAKPOINTS.md} {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 32px;
  }
`

export const RowData = styled.div`
  margin: 8px 0;

  @media ${BREAKPOINTS.md} {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 50%;
  }
`

export const NameLabel = styled.p`
  font-family: Ubuntu, sans-serif;
  font-size: 16px;
  font-weight: 300;
  line-height: 14px;
  letter-spacing: 0.02em;
  text-align: left;
  color: #6e6e6e;
  margin-right: 10px;
`

export const NameText = styled.p`
  font-family: Ubuntu, sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 14px;
  letter-spacing: 0.02em;
  text-align: left;
  color: #1f1f1f;
`

export const BirthdateLabel = styled(NameLabel)``

export const BirthdateText = styled(NameText)``

export const MoreDetailsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
`

export const MoreDetailsText = styled.p`
  font-family: Ubuntu, sans-serif;
  font-size: 16px;
  font-weight: 300;
  line-height: 14px;
  letter-spacing: 0.02em;
  text-align: left;
  color: #1f1f1f;
  cursor: pointer;
  text-decoration: underline;
`
